export const primaryBuy = {
  ADD_BANK: 'add_bank',
  VERIFY_BANK:'verify_bank'
};
